import type { UIViewInjectedProps } from '@uirouter/react';
import { observer } from 'mobx-react-lite';

import { api } from '@/api';
import { PERMISSION_OBJ_LOT } from '@/constants/permissions';
import { getAllowedFormFields } from '@/components/generic-form/utils';
import { DrawerForm } from '@/components/drawer-form';
import { lotStore, productStore } from '@/stores';
import { getTranslatedString } from '@/utils';
import { useMassUpdateCashedStores } from '@/utils/store';
import { showError } from '@/utils/common';

import { getFormFields } from './setup';

export const ProductForm = observer(({ transition }: UIViewInjectedProps) => {
  const { lotId } = transition.router.globals.params;
  const { selectedLots = [] } = transition.targetState().params();
  const { loading } = useMassUpdateCashedStores([productStore]);

  const resourceController = {
    create: async (values: any) => {
      const ids = selectedLots.length ? selectedLots : [lotId];
      try {
        const result = await api.lots.updateMany({ items: ids.map((id) => ({ id, productId: values.productId })) })
          .source;
        for (const item of result?.data?.items ?? []) {
          lotStore.updateItem(item);
        }
      } catch (err) {
        showError(err);
      }
    },
  };

  const onClose = () => {
    transition.router.stateService.go('base-layout.lots');
  };

  const initValues = {};
  const title = getTranslatedString('lot.product.title', { 0: selectedLots.join(', ') || lotId });
  const formFields = getFormFields();
  const allowedFields = getAllowedFormFields(formFields, true, PERMISSION_OBJ_LOT);

  return (
    <DrawerForm
      title={title}
      initValues={initValues}
      formFields={allowedFields}
      onClose={onClose}
      resourceController={resourceController}
      loaderCondition={loading}
    />
  );
});
